import '@umrah/site-kit/checkout.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { AppProviders } from '@/app/providers'
import { createRouter } from '@/app/router'
import { AddressGate } from '@/features/branding/address/AddressGate'
import { bootAddress, companyLanguage } from '@/features/branding/address/boot'
import { adoptDefaultLang } from '@/lib/i18n'
import { reloadForNewBuild } from '@/lib/staleBuild'
import '@/styles/index.css'
import '@/features/operations/company-logo.css'

// A file of an older release that is gone after a deploy (Vite's preload of a lazy route's files): reload once for the
// new release instead of failing the route.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewBuild()) event.preventDefault()
})

const container = document.getElementById('root')

if (container === null) {
  throw new Error('index.html is missing the #root element.')
}

// What this address is (P12) is asked once, before any route tree is made: GET /api/address picks the tree, the
// redirects, the favicon and — where the browser holds no choice of its own — the company's first language.
void bootAddress().then((boot) => {
  const language = companyLanguage(boot)
  if (language !== null) adoptDefaultLang(language)

  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <AddressGate boot={boot}>
          <RouterProvider router={createRouter(boot)} />
        </AddressGate>
      </AppProviders>
    </StrictMode>,
  )
})
